import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Radio, Spin, Select, Input, Tabs, Switch, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined, HomeOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, CaretRightOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import Message from '../../component/message/message';
import trans from './translation';

const { TabPane } = Tabs;
const { Option } = Select;

const TimedTask = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [tables, setTables] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [tablesCount, setTablesCount] = useState(0);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [jobGroupList, setJobGroupList] = useState([]);
    const [flag, setFlag] = useState("");
    const [executeOnceJobId, setExecuteOnceJobId] = useState(null);
    const [deleteMsg, setDeleteMsg] = useState(trans.confirmDelete[Config.backLang]);
    const [popupType, setPopupType] = useState("");
    const [jobModel, setJobModel] = useState({});
    const tableColumns = {
        jobName: "job_name",
        status: "status",
        jobGroup: "job_group"
    }


    useEffect(() => {
        search(pageSize, 1, "N");
        searchJobGroup();
    }, []);

    const searchJobGroup = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "SYS_JOB_GROUP" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                setJobGroupList(data.object);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();//清除提示信息
        clearSelect();//清除選中状态
        let model = {};
        if ("Y" === flag) {//是否使用原查询條件
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.page = currentPageNew;
        setIsLoad(true);
        setSpinInfo(trans.search2[Config.backLang])
        Base.callBackApi("sysJob/search", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                if (Base.isEmpty(data.object.list) && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const resetFrom = (model = {}) => {
        form.setFieldsValue({
            jobName: model.jobName ?? '',
            jobGroup: model.jobGroup ?? '',
            invokeTarget: model.invokeTarget ?? '',
            cronExpression: model.cronExpression ?? '',
            misfirePolicy: model.misfirePolicy ?? '',
            concurrent: model.concurrent ?? '',
            status: model.status ?? '',
        });
    }

    const add = () => {
        messageShowHandler();
        setTabIndex("2");
        setFlag("add");
        resetFrom({
            misfirePolicy: 1,
            concurrent: "N",
            status: "Y"
        });
    }

    const edit = () => {
        messageShowHandler();
        if (!checkboxState || checkboxState.length !== 1) {
            errFrameShow("error", trans.selectiveData[Config.backLang]);
        } else {
            setTabIndex("2");
            setFlag("edit");
            resetFrom(checkboxState[0]);
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        setCheckboxState([model]);
        setSelectedRowKeys([model.jobId]);
        resetFrom(model);
        setFlag("edit");
        setTabIndex("2");
    }

    const deleteFrameClose = (state) => {
        if (state) {
            if (popupType === "delete") {
                deleteJob();
            } else if (popupType === "execute") {
                executeOnce();
            } else if (popupType === "change") {
                changeStatus();
            }
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        messageShowHandler();
        setJobModel(model);
        setDeleteMsg(trans.confirmDelete[Config.backLang]);
        setPopupType("delete")
        setIsDeleteFrame(true);
    }

    const deleteJob = () => {
        let model = {
            menuFuncId: Config.funcInfo.funcId,
            jobIds: [jobModel.jobId],
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang]);
        Base.callBackApi("sysJob/delete", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                search(pageSize, current, "Y");
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const handleSelect = (key) => {
        messageShowHandler();//清除提示信息
        if (key !== undefined) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else {
                setTabIndex("1");
            }
        }
    }

    const onFinish = (values) => {
        values.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang]);
        let url = flag === "add" ? "insert" : "update";
        if (flag === "edit") {
            values.jobId = selectedRowKeys[0];
        }
        Base.callBackApi("sysJob/" + url, values).then((data) => {
            if ("SUCCESS" == data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    };


    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
    }

    const changeStatusPopup = (checked, model) => {
        messageShowHandler();
        if (checked) {
            model.status = "Y";
        } else {
            model.status = "N";
        }
        setJobModel(model);
        setDeleteMsg(trans.confirm[Config.backLang] + (checked ? trans.enable[Config.backLang] + '"' : trans.stop[Config.backLang] + '"') + model.jobName + '"' + trans.task[Config.backLang]);
        setPopupType("change");
        setIsDeleteFrame(true);
    }

    const changeStatus = () => {
        let model = jobModel;
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang]);
        Base.callBackApi("sysJob/changeStatus", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                search(pageSize, current, "Y");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const executeOncePopup = (model, e) => {
        e.stopPropagation();
        messageShowHandler();
        setExecuteOnceJobId(model.jobId);
        setDeleteMsg(trans.immediateExecution[Config.backLang] + '"' + model.jobName + '"' + trans.task[Config.backLang]);
        setPopupType("execute");
        setIsDeleteFrame(true);
    }

    const executeOnce = () => {
        setIsLoad(true);
        setSpinInfo(trans.taskExecution[Config.backLang]);
        Base.callBackApi("sysJob/run", executeOnceJobId).then((data) => {
            if ("SUCCESS" == data.msg) {
                errFrameShow("success", trans.executedSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    //分页 页码切换变化查询
    const onChange = (current, pageSize) => {
        search(pageSize, current, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (current, pageSize) => {
        search(pageSize, 1, "Y");
    }

    //列表1选中记录
    const onSelectChange = (keys, selectedRows) => {
        setSelectedRowKeys(keys);
        setCheckboxState(selectedRows);
    }

    //清空列表1选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const options = [
        { SC: '立即执行', TC: '立即執行', EN: 'Execute soon', value: 1 },
        { SC: '执行一次', TC: '執行一次', EN: 'Execute once', value: 2 },
        { SC: '放弃执行', TC: '放棄執行', EN: 'Abandon Execute', value: 3 },
    ]

    /*eslint-disable*/
    const columns = [
        {
            title: trans.jobName[Config.backLang],
            dataIndex: 'jobName',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobName') },
        },
        {
            title: trans.jobGroup[Config.backLang],
            dataIndex: 'jobGroup',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobGroup') },
            render: (text) => getJobGroup(text)
        },
        {
            title: trans.invokeTarget[Config.backLang],
            dataIndex: 'invokeTarget',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'invokeTarget') },
        },
        {
            title: trans.cronExpression[Config.backLang],
            dataIndex: 'cronExpression',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'cronExpression') },
        },
        {
            title: trans.status[Config.backLang],
            dataIndex: 'status',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: (text, record) => <Switch checked={text === "Y"} onChange={(e) => changeStatusPopup(e, JSON.parse(JSON.stringify(record)))} />
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'tableWidth20 sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysOperation' onClick={(e) => executeOncePopup(record, e)}><CaretRightOutlined /> {trans.executeOnce[Config.backLang]}</div>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ]
    /*eslint-enable*/

    const getJobGroup = (jobGroup) => {
        let model = jobGroupList.find(item => item.code == jobGroup);
        if (model) {
            return model.parmValue1;
        }
        return "";
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        hideDefaultSelections: true,
    };

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                {/* 删除弹框 */}
                {!isDeleteFrame ? '' : <PopupFrame close={deleteFrameClose} content={deleteMsg} />}
                {/* 审核彈框 */}
                <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder={trans.jobName[Config.backLang]} value={searchModel.jobName}
                                                onChange={(e) => searchChange('jobName', e.target.value)}
                                                onKeyDown={(e) => e.key == 13 ? search(pageSize, 1, "N", true) : null} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobGroup[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className='sysSelect' placeholder={trans.jobGroup[Config.backLang]}
                                                value={searchModel.jobGroup}
                                                onChange={(e) => searchChange('jobGroup', e)}
                                            >
                                                <Option value=""></Option>
                                                {jobGroupList.map((item) => <Option key={item.code} value={item.code}>{item.parmValue1}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.status[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder={trans.status[Config.backLang]}
                                                value={searchModel.status}
                                                onChange={(e) => searchChange('status', e)}
                                            >
                                                <Option value=""></Option>
                                                {context.jobStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                                <div className="sysLineEight"></div>
                                <Space size={[5, 5]} wrap className="sysButtonRelative">
                                    <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                </Space>
                                <div className="sysTable" id="tableOne">
                                    <Table
                                        scroll={{ x: 1200 }}
                                        rowKey="jobId"
                                        columns={columns} //列名
                                        dataSource={tables} //数据
                                        pagination={{  //分页
                                            showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                            onChange: onChange,                        //上页下页或者跳页方法
                                            onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                            total: tablesCount,             //总共多少条数据
                                            current: current,                //当前页
                                            pageSize: pageSize,              //每页显示多少条数据
                                            defaultCurrent: 1,                               //默认当前页为1
                                            size: "small"
                                        }}
                                        onRow={(record) => {
                                            return {
                                                onClick: event => Base.selectRowNew.call(this, record, 'jobId', checkboxState, selectedRowKeys, setCheckboxState, setSelectedRowKeys), // 点击行
                                            };
                                        }}
                                    />
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab={trans.timeTask[Config.backLang]} key="2" forceRender={true}>
                            <div className="sysSavePageWidth">
                                <Form form={form} name="sysJob" onFinish={onFinish}>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.jobName[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="jobName"
                                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                        { required: true, message: trans.jobNameNoIsNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder={trans.jobName[Config.backLang]} maxLength={64} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.jobGroup[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="jobGroup"
                                                >
                                                    <Select className="sysSelect" placeholder={trans.jobGroup[Config.backLang]}>
                                                        {jobGroupList.map((item) => <Option key={item.code} value={item.code}>{item.parmValue1}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.invokeTarget[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="invokeTarget"
                                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                        { required: true, message: trans.invokeTargetNoIsNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder={trans.invokeMethod[Config.backLang]} maxLength={500} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.cronExpression[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="cronExpression"
                                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                        { required: true, message: trans.invokeTargetNoIsNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder={trans.cronExpression[Config.backLang]} maxLength={255} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.misfirePolicy[Config.backLang]}</div>
                                            <div className="sysInputs">
                                                <Form.Item
                                                    name="misfirePolicy"
                                                >
                                                    <Radio.Group optionType="button" buttonStyle="solid" >
                                                        {options.map(item => <Radio key={item.value} value={item.value}>{item[Config.backLang]}</Radio>)}
                                                    </Radio.Group>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.concurrent[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="concurrent"
                                                >
                                                    <Radio.Group optionType="button" buttonStyle="solid" >
                                                        {context.concurrentMap.map(item => <Radio key={item.value} value={item.value}>{item[Config.backLang]}</Radio>)}
                                                    </Radio.Group>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.status[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="status"
                                                >
                                                    <Radio.Group >
                                                        {context.jobStatusMap.map(item => <Radio key={item.value} value={item.value}>{item[Config.backLang]}</Radio>)}
                                                    </Radio.Group>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sysSaveButton">
                                        <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                    </div>
                                </Form>
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default TimedTask;